<template>
  <div class="wrapper__content-sale-document col-container">
    <div class="col-header">
      <span class="col-title">Api Facturas</span>
      <div class="col-actions">
        <!-- <DownloadXML /> -->
        <ButtonFilterApiComponent
          @onChangeFilters="onChangeFilters"
          @onApplyFilters="onApplyFilters"
          @onResetFilters="onResetFilters"
          :setFilters="searchFilters"
          :loading="loading"
          :setStatus="filterStatus"
          placeholder="Buscar por número documento"
          isStatus
          isSearch
          isOrderBy
          isDates
          isClients
          class="mx-2"
        >
        </ButtonFilterApiComponent>
      </div>
    </div>
    <template>
      <WrapperScrollbarComponent @scrollingEnd="infiniteHandler">
        <InvoiceApiCardComponent
          v-for="(invoice, index) in filterInvoices"
          :key="index"
          :invoice="invoice"
        />
        <infinite-loading
          @distance="90"
          @infinite="infiniteHandler"
          ref="infiniteLoading"
        >
          <div slot="spinner">
            <SkeletonOneCardComponent />
          </div>
          <div slot="no-more"></div>
          <div slot="no-results">
            <InvoiceEmptyComponent v-if="!invoices.length" />
          </div>
        </infinite-loading>
      </WrapperScrollbarComponent>
    </template>
  </div>
</template>

<script>
import ButtonFilterApiComponent from "../../../components/DrawerFilter";
import InvoiceEmptyComponent from "./Empty";
import InvoiceApiCardComponent from "./InvoiceApiCard";
import SkeletonOneCardComponent from "@/components/Animations/Loading/SkeletonOneCard";
import WrapperScrollbarComponent from "../../../../components/WrapperScrollbar";

import invoiceService from "../services/invoiceService";

export default {
  name: "InvoiceApiColumnsComponent",
  data() {
    return {
      loading: true,
      searchFilters: {},
      filterIsPaid: null,
      filterStatus: [
        {
          label: "Pendiente",
          key: "pending"
        },
        {
          label: "Aprobada",
          key: "success"
        },
        {
          label: "Fallida",
          key: "failed"
        }
      ],
      page: 1,
      invoices: [],
      breakScroll: false,
      debounceTimer: null,
      customRangedates: null
    };
  },
  watch: {
    notication(newVal, oldVal) {
      if (oldVal === undefined) return;
      if (!newVal) return;
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.onAsyncDataForDates();
      }, 200);
    }
  },
  computed: {
    notication() {
      return this.$store.getters.getNotification;
    },
    filterOrderBy() {
      const { orderBy } = this.searchFilters;
      return orderBy;
    },
    requestFilters() {
      const { search, from, to, status, clientId: client } = this.searchFilters;
      // Only include defined/non-null values to prevent API confusion
      const filters = {};
      if (search) filters.search = search;
      if (from) filters.from = from;
      if (to) filters.to = to;
      if (status) filters.status = status;
      if (client) filters.client = client;
      return filters;
    },
    filterInvoices() {
      return this.invoices.concat().sort((a, b) => {
        if (this.filterOrderBy && this.filterOrderBy === "desc") {
          return a.total > b.total ? -1 : 1;
        } else if (this.filterOrderBy && this.filterOrderBy === "asc") {
          return a.total < b.total ? -1 : 1;
        }
        // Default: sort by date descending (most recent first)
        const dateA = a.created_at ? new Date(a.created_at) : new Date(0);
        const dateB = b.created_at ? new Date(b.created_at) : new Date(0);
        return dateB - dateA;
      });
    },
    getInvoicesFilters() {
      const { documents } = this.$store.getters.getModule("sales");
      return documents.invoices.filters.get;
    }
  },
  methods: {
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    onChangeFilterLocal() {
      this.updatedSearchFilters({
        is_paid: this.filterIsPaid
      });
    },
    updatedSearchFilters(filters) {
      this.searchFilters = {
        ...this.searchFilters,
        ...filters
      };

      this.$store.dispatch("salesDocumentsFiltersGet", {
        documentKey: "invoices",
        filters: this.searchFilters
      });
    },
    onChangeFilters(filters) {
      this.updatedSearchFilters(filters);
    },
    onApplyFilters() {
      this.onAsyncDataForDates();
    },
    onResetFilters() {
      this.filterIsPaid = null;

      this.onChangeFilterLocal();
    },
    onAsyncDataForDates() {
      this.invoices = [];
      this.page = 1;
      // El aviso de refresco llega con debounce: el componente puede haberse
      // desmontado (navegación) antes de que corra.
      if (!this.$refs.infiniteLoading) return;
      this.$refs.infiniteLoading.stateChanger.reset();
      this.$store.dispatch("sendNotification", false);
    },

    async getInvoices($state) {
      try {
        this.loading = true;
        let response = await invoiceService
          .getIntegrationInvoices({
            params: {
              ...{
                page: this.page,
                client: this.getClientId,
                is_paid: this.filterIsPaid
              },
              ...this.requestFilters
            }
          })
          .finally(() => {
            this.breakScroll = false;
            this.loading = false;
          });
        const { data } = response.data || {};
        // El interceptor de Api.js "silencia" los GET cancelados por deduplicación
        // devolviendo { data: {} }. Sin este guard, data.length revienta, el catch
        // se lo traga y $state nunca se resuelve: el infinite-loading queda colgado
        // y la columna solo vuelve a cargar recargando la página entera.
        if (!Array.isArray(data)) {
          $state.loaded();
          return;
        }

        if (data.length) {
          if (this.page === 1) {
            this.invoices = data;
          } else {
            // Deduplicate: only push items not already in the list
            const existingIds = new Set(this.invoices.map(i => i.id));
            const newItems = data.filter(item => !existingIds.has(item.id));
            if (newItems.length === 0) {
              // All returned items are already shown — no more unique data
              $state.complete();
              return;
            }
            newItems.forEach(item => this.invoices.push(item));
          }
          this.page = this.page + 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (error) {
        return false;
      }
    },
    infiniteHandler($state) {
      if (!$state || typeof $state.complete !== "function") return;
      if (this.breakScroll) return false;
      this.breakScroll = true;
      this.getInvoices($state);
    },
    setInitFilters() {
      // All filters
      this.searchFilters = this.getInvoicesFilters;

      // Local filters
      this.filterIsPaid = this.getInvoicesFilters?.is_paid;
    }
  },
  components: {
    // ButtonCirclePlusComponent,
    ButtonFilterApiComponent,
    InvoiceEmptyComponent,
    InvoiceApiCardComponent,
    SkeletonOneCardComponent,
    WrapperScrollbarComponent
    // DownloadXML
  },
  props: {
    getClientId: {
      default: null
    }
  },
  mounted() {
    this.setInitFilters();
  }
};
</script>

<style lang="scss" scoped></style>
